import { ErrorMessages, ErrorDescriptions } from './errors';
import { CombinedError } from 'urql';
import Auth from '../../redux/auth';
import store from '../../redux/store';
import Presentation from '../../redux/presentation';

export const handleError = (error: CombinedError): void => {
  switch (error.message) {
    case ErrorMessages.AuthenticationError: {
      const loggedIn = Auth.select.selectLoggedIn(store.getState());
      if (loggedIn) {
        store.dispatch(Auth.actions.resetStore());
        store.dispatch(Auth.actions.setUserLoggedOut());
        console.log(
          'Logged out, because of client recieved an authentication_error in a graphql operation',
        );
      }
      break;
    }
    case ErrorMessages.InvalidSecretError:
      break;
    case ErrorMessages.DuplicateNewPasswordError:
      break;
    default:
      store.dispatch(
        Presentation.actions.setToast(ErrorDescriptions[error.message] || 'common.unexpectedError', {
          appearance: 'error',
          autoDismiss: false,
        }),
      );
      break;
  }
};
